export const cs = {
  partnerApp: "RestaurantFlicko",
};
